import { Component, signal, inject, DestroyRef } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { HeaderComponent } from './components/header/header';
import { FooterComponent } from "./components/footer/footer";
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
import { NotificationsService } from './services/notifications/notifications.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, FooterComponent, LoadingSpinnerComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);
  private notificationsService = inject(NotificationsService);

  protected readonly title = signal('my-app');
  protected readonly isAdminRoute = signal(false);

  constructor() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((event: NavigationEnd) => {
        this.isAdminRoute.set(event.url.startsWith('/admin'));
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    this.notificationsService.fetchNotificationCounts();
  }
}
